export const VARIATION = [
  'important',
  'neutral'
]
